export const RootActionEvent = 'action';

export const RootActionType = {
    SHARE: 'share'
};
